import { ClickAndCollectCountdownUI } from "./ClickAndCollectCountdownUI";
import { StandardProps } from "../componentMap";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";
import { useVariant } from "../../hooks/useVariant/useVariant";

const CLICK_AND_COLLECT_DMS_CODE = "187";

export function ClickAndCollectCountdown({
  product,
}: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);
  if (product.__typename !== "SimpleProduct") return null;
  const activeVariant = ensureIsActiveVariant(variant);
  if (!activeVariant) return null;
  const { availability } = activeVariant;

  if (
    !availability.availableToOrder ||
    availability.futureAvailability ||
    availability.preOrder
  )
    return null;

  const clickAndCollectFulfilmentOption =
    product.fulfilmentOptions.available.find(
      (option) => option.aliases?.dmsId === CLICK_AND_COLLECT_DMS_CODE,
    );

  if (!clickAndCollectFulfilmentOption) return null;

  return (
    <ClickAndCollectCountdownUI
      orderByLocalTimeToday={
        clickAndCollectFulfilmentOption.earliestFulfilment
          ?.orderByLocalTimeToday
      }
      collectFromLocalTimeTomorrow={
        clickAndCollectFulfilmentOption.earliestFulfilment
          ?.collectFromLocalTimeTomorrow
      }
      duration={3}
    />
  );
}
